"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.videoTileDidUpdateHandlerForHost = videoTileDidUpdateHandlerForHost;
exports.videoTileDidUpdateHandlerForMixer = videoTileDidUpdateHandlerForMixer;
exports.videoTileDidUpdateHandlerForSpeaker = videoTileDidUpdateHandlerForSpeaker;
var _underscore = _interopRequireDefault(require("underscore"));
var _StudioLogger = require("@studio/logger/StudioLogger");
var _logger = require("../../../constants/logger");
var _getAttendeePresenceFunc = require("../../onPresenceChanged/getAttendeePresenceFunc");
var _subscribeToVolumeIndicator = require("../../subscribeToVolumeIndicator");
var _Sources = require("@studio/constants/Sources");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var logger = new _StudioLogger.StudioLogger(_logger.loggerName);
var subscribeToVolumeIndicatorOnce = _underscore["default"].once(_subscribeToVolumeIndicator.subscribeToVolumeIndicator);
function videoTileDidUpdateHandlerForHost(dispatch, actions, meetingSession) {
  return function videoTileDidUpdateHandler(tileState) {
    var disconnectSource = actions.disconnectSource,
      setAttendeePresence = actions.setAttendeePresence,
      setAttendeeTile = actions.setAttendeeTile,
      setMeetingDirectorValue = actions.setMeetingDirectorValue,
      setAttendeeMuteStatus = actions.setAttendeeMuteStatus,
      setAttendeeVoiceIntensity = actions.setAttendeeVoiceIntensity;

    // Ignore a tile without attendee ID and other attendee's tile.
    var attendeeId = tileState.boundAttendeeId;
    if (!attendeeId) {
      return;
    }
    logger.info('Chime - VideoTileDidUpdateForHost Event', _objectSpread(_objectSpread({
      chimeEventName: 'VideoTileDidUpdate'
    }, tileState), {}, {
      'attendee-id': attendeeId
    }));
    var setPresence = (0, _getAttendeePresenceFunc.getAttendeePresenceFunc)(dispatch, {
      disconnectSource: disconnectSource,
      setAttendeePresence: setAttendeePresence
    }, attendeeId);
    setPresence(attendeeId, true);
    subscribeToVolumeIndicatorOnce(dispatch, setAttendeeMuteStatus, meetingSession, attendeeId, setAttendeeVoiceIntensity);
    dispatch(setAttendeeTile(tileState));
    if (!tileState.isContent && tileState.localTile) {
      dispatch(setMeetingDirectorValue(tileState.boundAttendeeId));
    }
  };
}
function videoTileDidUpdateHandlerForSpeaker(dispatch, actions, meetingSession, setProgram) {
  return function videoTileDidUpdateHandler(tileState) {
    var setAttendeeTile = actions.setAttendeeTile,
      persistAttendeeId = actions.persistAttendeeId,
      setAttendeeCameraStatus = actions.setAttendeeCameraStatus,
      setAttendeeVoiceIntensity = actions.setAttendeeVoiceIntensity;
    // Ignore a tile without attendee ID and other attendee's tile.
    if (!tileState.boundAttendeeId) {
      return;
    }
    var remoteVideoSources = (meetingSession.audioVideo.getRemoteVideoSources() || []).filter(function (source) {
      var _source$attendee;
      return !(source !== null && source !== void 0 && (_source$attendee = source.attendee) !== null && _source$attendee !== void 0 && (_source$attendee = _source$attendee.attendeeId) !== null && _source$attendee !== void 0 && _source$attendee.includes('#content'));
    });

    //Note: you can access tileState.isContent to determine if it's a screen share, or a non-camera source
    dispatch(setAttendeeTile(tileState));
    // Persist for local attendee
    if (tileState.localTile) {
      dispatch(persistAttendeeId(tileState.boundAttendeeId));
      // Sets initial camera status for all remote attendees when joining the meeting
      remoteVideoSources.forEach(function (source) {
        var _source$attendee2;
        var attendeeId = source === null || source === void 0 || (_source$attendee2 = source.attendee) === null || _source$attendee2 === void 0 ? void 0 : _source$attendee2.attendeeId;
        if (attendeeId) {
          dispatch(setAttendeeCameraStatus(attendeeId, true, setProgram));
        }
      });
    }

    // Only set camera status for tiles which is not the local tile, and it's not a screenshare tile
    if (!tileState.localTile && !tileState.boundAttendeeId.includes('#content')) {
      // Sets camera status for new attendee if below the camera limit
      if (remoteVideoSources.length < _Sources.MAX_CAMERA_COUNT) {
        dispatch(setAttendeeCameraStatus(tileState.boundAttendeeId, true, setProgram));
      }
    }
    if (!!setAttendeeVoiceIntensity) {
      subscribeToVolumeIndicatorOnce(dispatch, null, meetingSession, tileState.boundAttendeeId, setAttendeeVoiceIntensity);
    }
  };
}
function videoTileDidUpdateHandlerForMixer(dispatch, setAttendeeTile, setAttendeeCameraStatus, attendeeCameraStatusHandler, meetingSession) {
  return function videoTileDidUpdateHandler(tileState) {
    // Ignore a tile without attendee ID and other attendee's tile.
    if (!tileState.boundAttendeeId) return;
    logger.info('Chime - VideoTileDidUpdate Event', _objectSpread(_objectSpread({}, tileState), {}, {
      'attendee-id': tileState.boundAttendeeId
    }));
    dispatch(setAttendeeTile(tileState));
    if (!tileState.boundAttendeeId.includes('#content')) {
      attendeeCameraStatusHandler(meetingSession, dispatch, setAttendeeCameraStatus);
    }
  };
}